import { isErrorResponse } from '@standardnotes/responses';
import { Result } from '@standardnotes/domain-core';
export class ReuploadAllInvites {
    constructor(reuploadInvite, findContact, inviteServer) {
        this.reuploadInvite = reuploadInvite;
        this.findContact = findContact;
        this.inviteServer = inviteServer;
    }
    async execute(params) {
        const invites = await this.getExistingInvites();
        if (invites.isFailed()) {
            return invites;
        }
        const deleteResult = await this.deleteExistingInvites();
        if (deleteResult.isFailed()) {
            return deleteResult;
        }
        const errors = [];
        for (const invite of invites.getValue()) {
            const recipient = this.findContact.execute({ userUuid: invite.user_uuid });
            if (recipient.isFailed()) {
                errors.push(`Contact not found for invite ${invite.user_uuid}`);
                continue;
            }
            const result = await this.reuploadInvite.execute({
                keys: params.keys,
                previousKeys: params.previousKeys,
                recipient: recipient.getValue(),
                previousInvite: invite,
            });
            if (result.isFailed()) {
                errors.push(result.getError());
            }
        }
        if (errors.length > 0) {
            return Result.fail(errors.join(', '));
        }
        return Result.ok();
    }
    async getExistingInvites() {
        const response = await this.inviteServer.getOutboundUserInvites();
        if (isErrorResponse(response)) {
            return Result.fail(`Failed to get outbound user invites ${JSON.stringify(response)}`);
        }
        const invites = response.data.invites;
        return Result.ok(invites);
    }
    async deleteExistingInvites() {
        const response = await this.inviteServer.deleteAllOutboundInvites();
        if (isErrorResponse(response)) {
            return Result.fail(`Failed to delete existing invites ${JSON.stringify(response)}`);
        }
        return Result.ok();
    }
}
